function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-support-contact-form\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15,29.59H6.31a4.19,4.19,0,0,1-4-4.35V6.71a1.13,1.13,0,0,1,2.25,0V25.24a2,2,0,0,0,1.74,2.1H15a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.69,29.59H24.06a1.13,1.13,0,0,1,0-2.25h9.63a2,2,0,0,0,1.74-2.1V6.71A2,2,0,0,0,33.69,4.6H6.31A2,2,0,0,0,4.57,6.71a1.13,1.13,0,1,1-2.25,0,4.19,4.19,0,0,1,4-4.36H33.69a4.19,4.19,0,0,1,4,4.36V25.24A4.19,4.19,0,0,1,33.69,29.59Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20,19a1.13,1.13,0,0,1-1.13-1.12,4.66,4.66,0,0,1,2.37-4.19A2.76,2.76,0,0,0,22.78,11,2.65,2.65,0,0,0,20,8.51,2.65,2.65,0,0,0,17.22,11,1.13,1.13,0,1,1,15,11a4.89,4.89,0,0,1,5-4.73A4.89,4.89,0,0,1,25,11a4.94,4.94,0,0,1-2.48,4.52c-.89.64-1.43,1-1.43,2.36A1.12,1.12,0,0,1,20,19Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 22.67,
  r: 1.74,
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12,38.55a1.07,1.07,0,0,1-.66-.22,1.13,1.13,0,0,1-.41-1.27l3-9a1.13,1.13,0,1,1,2.14.72l-1.89,5.55,9.21-6.81A1.13,1.13,0,0,1,25,27.8a1.12,1.12,0,0,1-.24,1.57l-12.1,9A1.17,1.17,0,0,1,12,38.55Z",
  fill: "#231f20"
});

function SvgCmsSupportContactForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCmsSupportContactForm;